module.exports = __webpack_public_path__ + "static/media/siddharth-vijayawada-trip-04.65ff3c29.png";